import { InputAdornment, TextField } from "@mui/material";
import PropTypes from "prop-types";
import { memo } from "react";

const InputField = ({
  placeholder,
  name,
  value,
  onChange,
  InputStartIcon,
  type = "text",
  InputEndIcon,
  id,
  fullWidth = true,
  multiline = false,
  rows,
  disabled = false,
  readonly = false,
  maxLength = 255,
  inputError = false,
  helperText = "",
  variant = "outlined",
  size = "small",
  required = false,
  styleProps = {},
  onkeydown,
  autoFocus
}) => {
  return (
    <TextField
      sx={styleProps}
      required={required}
      error={inputError}
      helperText={helperText}
      id={id}
      inputProps={{ maxLength }}
      type={type}
      variant={variant}
      size={size}
      fullWidth={fullWidth}
      placeholder={placeholder}
      name={name}
      value={value}
      onChange={onChange}
      multiline={multiline}
      rows={rows}
      disabled={disabled}
      autoFocus={autoFocus}
      onKeyDown={onkeydown}
      InputProps={{
        
        readOnly: readonly,
        startAdornment: InputStartIcon && (
          <InputAdornment position="start">{InputStartIcon}</InputAdornment>
        ),
        endAdornment: InputEndIcon && (
          <InputAdornment position="end">{InputEndIcon}</InputAdornment>
        ),
      }}
    />
  );
};

InputField.propTypes = {
  placeholder: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  InputStartIcon: PropTypes.node,
  type: PropTypes.string,
  InputEndIcon: PropTypes.node,
  id: PropTypes.string,
  fullWidth: PropTypes.bool,
  multiline: PropTypes.bool,
  rows: PropTypes.number,
  disabled: PropTypes.bool,
  readonly: PropTypes.bool,
  maxLength: PropTypes.number,
  inputError: PropTypes.bool,
  helperText: PropTypes.string,
  variant: PropTypes.string,
  size: PropTypes.string,
  autoFocus: PropTypes.bool,
  required: PropTypes.bool,
  styleProps: PropTypes.object,

};

export default memo(InputField);
